import React from 'react';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import { NodeVacancy } from '../../../../types/uncinc_profile/nodes';
import { SCREEN_NORMAL } from '../../../../config/constants';
import TeaserSmall from '../../../../components/Teaser/Small';
import TeaserBig from '../../../../components/Teaser/Big';

interface NodeVacancyTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeVacancy>;
}

const NodeVacancyTeaser: React.FC<NodeVacancyTeaserProps> = ({ entity }) => {
  const { t } = useTranslation();
  const vacancy = entity.toJS();
  const { width } = useWindowDimensions();
  const type = t('content_types.vacancy.type');

  return (
    <div>
      {width < SCREEN_NORMAL ? (
        <TeaserSmall
          node={vacancy}
          typeLabel={type}
        />
      ) : (
        <TeaserBig
          node={vacancy}
          typeLabel={type}
        />
      )}
    </div>
  );
};

export default NodeVacancyTeaser;
